import { useEffect, useState } from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { hasToken, useSessionReady } from '../../hooks/useSessionReady';
import { ORDER_CHANGES_CHANGED_EVENT, fetchOrderChangeCount } from './orderChangesApi';

/**
 * Pozycja „Zmiany zleceń” w menu z licznikiem zmian w toku (makieta back
 * office v2, fala B, B9, 21.10.2026; menu makiety: „Zmiany zleceń” z liczbą).
 * Menu pokazuje pozycję tylko z przełącznikiem i przyjęciem zleceń, więc
 * licznik pyta API tylko wtedy. Zero i błąd odczytu — sama etykieta.
 * Odświeża się co minutę i od razu po zmianie w tej karcie przeglądarki.
 */

export const ORDER_CHANGES_REFRESH_MS = 60_000;

export const OrderChangesMenuLabel = ({ label }: { label: string }) => {
  const ready = useSessionReady();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!ready) {
      setCount(null);
      return undefined;
    }
    let active = true;
    const load = () => {
      if (!hasToken()) return;
      fetchOrderChangeCount()
        .then((c) => {
          if (active) setCount(c);
        })
        .catch(() => {
          if (active) setCount(null);
        });
    };
    load();
    const timer = setInterval(load, ORDER_CHANGES_REFRESH_MS);
    window.addEventListener(ORDER_CHANGES_CHANGED_EVENT, load);
    return () => {
      active = false;
      clearInterval(timer);
      window.removeEventListener(ORDER_CHANGES_CHANGED_EVENT, load);
    };
  }, [ready]);

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
      <span>{label}</span>
      {count !== null && count > 0 ? (
        <Tooltip title={`Zmiany zleceń w toku: ${count}`}>
          <Chip
            size="small"
            color="warning"
            label={count}
            data-testid="order-changes-count"
            sx={{ height: 18, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
          />
        </Tooltip>
      ) : null}
    </Box>
  );
};
